/**
 * Maps an array of data items to a template.
 * @param {Array} results
 * @param {jQuery} $itemTemplate
 * @return {Element[]}
 */
const mapTopicDataToTemplate = (results, $itemTemplate) =>
    results.map((entry) => {
        const $item = $itemTemplate.clone();
        $item.find('[data-path]').text(entry.path);
        $item.find('[data-title]').text(entry.title);
        $item.find('[data-text]').text(entry.text);
        $item
            .find('[data-img]')
            .attr('src', entry.img.replace('/home/10013_ansorg.com//w', ''));
        $item.find('[data-url]').attr('href', entry.url);

        return $item.get(0);
    });

export default mapTopicDataToTemplate;



// WEBPACK FOOTER //
// ./src/scripts/components/search/mapTopicDataToTemplate.js